import React from 'react';

const StampDutyAssumptionContent = () => {
  return (
    <React.Fragment>
      <p>
        The Stamp Duty Calculator results are intended as a guide only and are an estimate based on the information you input.
      </p>
      <p>
        The stamp duty rates used in the calculator are current and applicable for Australian purchasers as at September 2021 and are subject to change by the relevant States and Territories. Different stamp duty rates apply to foreign purchasers. You may be eligible for stamp duty exemptions/concessions such as first homeowners grant and other concessions that may be applicable to you. You should check with your solicitor, conveyancer or revenue office to confirm whether you are eligible for any concessions.
      </p>
      <p>
        Terms, conditions and eligibility criteria apply to all of our loan products and features. Fees, charges and disbursements are payable. Final approval is subject to our full credit assessment.
      </p>
      <p>
        We recommend that you consult our Loan Consultants or your professional adviser before making any decision based on this information.
      </p>
    </React.Fragment>
  )
}

export default StampDutyAssumptionContent;
